<template>
  <div class="option-block">
    <input type="text" :value="this.option.label" class="option-label" @change="setLabel($event)">
    <input type="text" :value="this.option.value" class="option-value" @change="setValue($event)">
    <span class="remove" @click="removeOption()">&#9866;</span>
  </div>
</template>

<script>
export default {
  name: "Option",
  props: {
    option: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    }
  },
  methods: {
    setLabel: function(event) {
      this.option.label = event.target.value
    },
    setValue: function(event) {
      this.option.value = event.target.value
    },
    removeOption: function() {
      this.$emit("removeOption", this.index)
    }
  }
}
</script>

<style scoped>
.option-block {
  border: 1px dashed #000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 8px;
  background: #ECECEC;
  width: 100%;
  box-sizing: border-box;
}

.option-block input {
  padding: 8px;
}

.option-label {
  width: 20rem;
}

.option-value {
  width: 8rem;
}

.remove {
  text-align: center;
  background: #fff;
  border: 1px solid #000;
  border-radius: 20px;
  padding: 1px 5px 2px;
  margin-top: 3px;
  margin-left: 5px;
  font-weight: bolder;
  cursor: pointer;
}
</style>